import { Slider } from '@mui/material';
import { useState } from 'react';
import { MIN_FABRIC_IMAGE_SCALE } from '../../imageSizing';

interface Props {
  label: string
  value: number
  onChange: (value: number) => void
}

export default function FabricScaleSlider({ label, value, onChange }: Props) {
  // Keep endpoints stable while dragging, including an initial size outside the usual range.
  const [range] = useState(() => ({ min: Math.min(MIN_FABRIC_IMAGE_SCALE, value), max: Math.max(1.5, value) }));

  return <Slider
    aria-label={label}
    value={value}
    min={range.min}
    max={range.max}
    step={0.01}
    valueLabelDisplay="auto"
    onChange={(event, nextValue) => onChange(Number(nextValue))}
  />;
}
